import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function SkipOrderIcon(props) {
  return (
    <SvgIcon viewBox="0 0 61 60" {...props}>
      <title>Skip Order</title>
      <g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M45.509 18.4287L42.1275 21.8102C45.1511 24.8102 47.0326 28.976 47.0326 33.5704C47.0326 42.7848 39.5796 50.2399 30.3673 50.2399C21.1529 50.2399 13.6978 42.7848 13.6978 33.5704C13.6978 26.9617 17.5422 21.2766 23.1115 18.5787V24.0474L30.2302 16.9115C30.2774 16.9115 30.3202 16.9051 30.3673 16.9051V24.0474L39.9611 14.4279L39.6289 14.2629L30.3673 4.99924V12.1415C30.3309 12.1415 30.2945 12.1479 30.2602 12.1479L23.1115 4.99924V13.4294C14.8528 16.4058 8.93848 24.2874 8.93848 33.5704C8.93848 45.4055 18.5322 54.9992 30.3673 54.9992C42.2004 54.9992 51.7962 45.4055 51.7962 33.5704C51.7962 27.6431 49.3919 22.3116 45.509 18.4287Z"
        />
      </g>
    </SvgIcon>
  );
}

export default SkipOrderIcon;
